import noUiSlider from 'nouislider';

export default function createYearSlider(range, update = () => null) {
  const actualInput = range.nextElementSibling;
  const min = parseInt(range.getAttribute('min'), 10);
  const max = parseInt(range.getAttribute('max'), 10);

  const slider = noUiSlider.create(range, {
    range: {
      min,
      max,
    },
    format: {
      to: value => value,
      from: value => parseInt(value, 10),
    },
    start: [min, max],
    connect: true,

    step: 1,
    tooltips: true,
  });

  slider.on('set', ([min, max]) => {
    actualInput.value = `${min}-${max}`;

    update();
  });
}
